import { API_PATHS } from "../../config/ApiPaths";

export const apiRevenueMytel = (stateDate, endDate) => {
  return `${API_PATHS.mytelRevenue}?startDate=${stateDate}&endDate=${endDate}`;
};
export const apiRevenueMagicWheel = (stateDate, endDate) => {
  return `${API_PATHS.mytelMagicWheel}?startDate=${stateDate}&endDate=${endDate}`;
};
export const apiErrorCodeMytel = (stateDate, endDate) => {
  return `${API_PATHS.mytelErrorCode}?startDate=${stateDate}&endDate=${endDate}`;
};
